export default function AppEntry() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-14 bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/60">
          <div className="w-20 h-20 md:w-24 md:h-24 shrink-0 rounded-2xl bg-primary-500 flex items-center justify-center">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-background-50"></i>
          </div>

          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">小草影院 移动端观影</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              小草影院全面适配手机与平板设备，无论您使用 iOS 还是 Android 系统，打开浏览器即可享受与电脑端一致的高清流畅观影体验。无需下载安装任何 App，省内存、零广告骚扰，随时随地免费在线看电影电视剧。支持横屏全屏播放、记忆播放进度，让碎片时间也能轻松追剧。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
              <div className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-foreground-950 text-background-50 text-sm font-medium cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-apple-line text-lg"></i>
                iOS 网页版
              </div>
              <div className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-foreground-950 text-background-50 text-sm font-medium cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-android-line text-lg"></i>
                Android 网页版
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}